



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import request, { Response } from '@/helpers/requests'
import { PhoneNumber } from '@/pages/PhoneNumberManagement/types/phone-number'


interface LoadResponseData extends Response {
    data: PhoneNumber[];
}


@Component
export default class AvailableNumberTable extends Vue {
    loading = false
    @Prop() pulsemAccountId: number|null = null
    @Prop() locationValid = false
    phoneNumbers: PhoneNumber[] = []
    headers = [
        { text: 'Phone Number', value: 'phoneNumber', align: 'left' },
        { text: 'Type', value: 'type', align: 'left' },
        { text: 'Vanity', value: 'vanity' },
        { text: 'App Code', value: 'appCode' }
    ]

    @Watch('locationValid')
    locationValidityUpdated(newVal: boolean) {
        this.locationValid = newVal
        if (this.locationValid) {
            this.load()
        }
    }

    async load() {
        this.loading = true
        const resp = await request.post('/support/location-number-list', {
            pulsemAccountId: this.pulsemAccountId
        }) as LoadResponseData
        this.phoneNumbers = resp.data
        this.loading = false
        return resp
    }
}
